"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendMessageToService = exports.messageToJsonRPC = void 0;

var _uuid = require("uuid");

const messageToJsonRPC = message => {
  console.log("went through messageToJsonRPC with: ", message);
  let msgObj;

  try {
    msgObj = JSON.parse(message);
  } catch (e) {
    return new Error(`An error ocurred due to a malformed message: ${e}`);
  }

  const {
    targetContext,
    action,
    query,
    eventName,
    payload
  } = msgObj;
  return JSON.stringify({
    jsonrpc: "2.0",
    method: [].concat(targetContext ? targetContext : []).concat(action ? action : []).concat(eventName ? eventName : []).concat(query ? query : []).join("."),
    params: payload,
    id: (0, _uuid.v4)()
  });
};

exports.messageToJsonRPC = messageToJsonRPC;

const sendMessageToService = fetch => endpoint => async message => fetch(endpoint, {
  method: "POST",
  body: messageToJsonRPC(message)
}).then(res => res.json()).then(res => {
  var _res$error;

  if (res !== null && res !== void 0 && (_res$error = res.error) !== null && _res$error !== void 0 && _res$error.message) {
    console.log("An error occurred: ", res.error.message);
    return res.error.message;
  }

  return res.result;
}).catch(res => console.log("An error occurred: ", res));

exports.sendMessageToService = sendMessageToService;